import { combineEpics, ofType } from "redux-observable"
import { from, of, concat, EMPTY } from "rxjs"
import { catchError, mergeMap, switchMap, ignoreElements } from "rxjs/operators"
import { Epic } from "../../epics"
import * as actions from "./actions"
import { addErrorNotification } from "../notifications/actions"
import { RequestCancelledError } from "../../errors"
import { FlowControlDTO } from "../../apis/models/fields"

export const initializeEpic: Epic = (action$) =>
    action$.pipe(
        ofType(actions.INITIALIZE),
        mergeMap(() => of(actions.requestStateTransitionButtons())),
    )

export const defaultRequestStateTransitionButtonsErrorMessage =
    "Something went wrong when fetching state transition buttons."

export const requestStateTransitionButtonsEpic: Epic = (
    action$,
    state$,
    { resourceFooter: { fieldsAPI } },
) =>
    action$.pipe(
        ofType(actions.REQUEST_STATE_TRANSITION_BUTTONS),
        mergeMap(() =>
            from(
                fieldsAPI.collectStateTransitionButtons(
                    state$.value.resourceFooter.itemId,
                ),
            ).pipe(
                mergeMap((buttons: FlowControlDTO[]) =>
                    of(actions.receiveStateTransitionButtons(buttons)),
                ),
                catchError((error) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    return concat(
                        of(
                            actions.receiveStateTransitionButtons(
                                state$.value.resourceFooter.buttons,
                            ),
                        ),
                        of(
                            addErrorNotification(
                                defaultRequestStateTransitionButtonsErrorMessage,
                            ),
                        ),
                    )
                }),
            ),
        ),
    )

export const clickStateTransitionButtonEpic: Epic = (
    action$,
    state$,
    { resourceFooter: { ipeAPI } },
) =>
    action$.pipe(
        ofType(actions.CLICK_STATE_TRANSITION_BUTTON),
        switchMap((action: actions.ClickStateTransitionButton) => {
            return from(
                ipeAPI.saveIPE(
                    {
                        object: "Item",
                        objectId: state$.value.resourceFooter.itemId,
                        propertyId: 7,
                    },
                    action.toItemStatusId,
                ),
            ).pipe(
                ignoreElements(),
                catchError((error: unknown) => {
                    if (error instanceof RequestCancelledError) {
                        return EMPTY
                    }
                    console.error(error)
                    // Maybe the transition is not valid anymore and we missed a change.
                    return of(actions.requestStateTransitionButtons())
                }),
            )
        }),
    )

export default combineEpics(
    initializeEpic,
    requestStateTransitionButtonsEpic,
    clickStateTransitionButtonEpic,
)
